import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background: #00000065;
  width: 100vw;
  height: 100vh;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Content = styled.div`
  background: #ffffff;

  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.16);
  border-radius: 10px;
  padding: 32px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* gap: 32px; */
  min-width: 360px;


  .icon {
    margin-bottom: 8px;

    svg {
      stroke-width: 3px;
      background: ${({ theme }) => theme.colors.orange.primary};
      padding: 4px;
      border-radius: 50%;
      color: ${({ theme }) => theme.colors.white};
    }
  }

  .title {
    font-size: 18px;
    font-weight: 600;
  }

  .text {
    margin: 8px 0 16px;
  }

  .upload-box {
    min-height: 100%;
    display: flex;
    flex-direction: column;
    width: 500px;
    padding: 30px;
    margin-top: 20px;
    margin-bottom: 10px;
    
    .box {
      text-align: center;
      color: white;
      font-family: sans-serif;
      font-size: 36px;
      padding: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    
    .box-1 {
      height: 60px;
    }
    
    .box-2 {
      height: 10px;
    }
    
    .box-3 {
      background-color: red;
      height: 10px;
    }
  }
`;
